import React, { memo, useState } from "react";
import { Video } from "~/common/Store/models/Video";
import Icon from "~/common/Icons/Standard/index";
import ZestVideoPlayer from "~/common/videoPlayer/ZestVideoPlayer";

interface Props {
  video: Video;
  autoPlay: boolean;
  muted: boolean;
  mounted: boolean;
  shouldLoopVideo: boolean;
  playVideo: boolean;
}

// This component exists to address performance concerns with initial page load
// by using a "fake video" placeholder with a play button over the video poster
// then replacing it with the real video once play button is clicked
const ProductListingVideo = ({
  video,
  autoPlay,
  muted,
  mounted,
  shouldLoopVideo,
  playVideo,
}: Props) => {
  const [displayVideo, setDisplayVideo] = useState(autoPlay);

  return mounted && displayVideo ? (
    <div data-testid="video-container">
      <ZestVideoPlayer
        posterImage={video.poster}
        sources={video.sources}
        activePlayer={playVideo}
        currentIndex={0}
        selected={0}
        autoPlay={playVideo}
        playsInline
        closedCaptionsrc={video.closedCaptionFile}
        muted={muted}
        shouldLoopVideo={shouldLoopVideo}
      />
    </div>
  ) : (
    <div
      className="relative w-full h-full"
      data-testid="video-placeholder"
      style={{ minHeight: "210px" }}
    >
      <img
        alt=""
        className="h-full object-contain focus:outline-none w-full"
        src={video.poster}
      />
      <div className="absolute w-full top-1/2 -translate-y-1/2 z-9">
        <div className="items-center justify-center w-full flex">
          <button
            type="button"
            onClick={() => setDisplayVideo(true)}
            className="text-white fill-current w-20 h-20 bg-transparent px-0 border-0 cursor-pointer flex justify-center items-center transition-opacity ease-in-out duration-150 opacity-50 focus:outline-none hover:opacity-100"
            data-testid="video-placeholder-play-button"
          >
            <Icon
              name="play"
              key={playVideo.toString()}
              className="w-20 h-20"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default memo(ProductListingVideo);
